<template lang="pug">
  .default-pdp(v-if="product && product.id" itemprop="product" itemscope itemtype="http://schema.org/Product")
    PdpBanner

    template(v-if='hasActiveSub')
      PdpExistingSubBanner

    FixedWidthContainer
      DefaultPdpHero

    FixedWidthContainer
      PdpInfoBullets(:bullets="product.prodInfo")

    LazyComponent
      template(#default="{ shown }")
        AccordionSections(v-if="shown")

    template(v-if="cmsSettings.customComponents && cmsSettings.customComponents.length")
      LazyComponent(v-for="(componentConfig, index) in cmsSettings.customComponents" :key="index")
        template(#default="{ shown }")
          CMSPartial(v-if="componentConfig.mixin_key === 'partial-loader'" :mixin-key="componentConfig.settings.partial")
          ComponentResolver(v-else :component-name="componentConfig.mixin_key" :component-props="componentConfig.settings")

    LazyComponent
      template(#default="{ shown }")
        LockupBanner(v-if="shown" :cms="cmsSettings.moneyBackGuarantee")

    LazyComponent
      template(#default="{ shown }")
        FixedWidthContainer(v-if="shown")
          .xs-12.xs-mt-400m.xs-mb-200m.xs-pb-300m.b-line
            ExpertiseIncluded

    LazyComponent
      template(#default="{ shown }")
        FixedWidthContainer(v-if="shown && remainingXsellItemsAvailable.length > 0")
          .b-line
            h3.text-center
              span.bold.upper.xs-f-small.lg-f-large.max-at-tweak Recommended
              br
              span.text-color-2.xs-f-medium.lg-f-xmedium.max-at-tweak  with {{ product.name }}
            PdpXsellCarousel(:items="remainingXsellItemsAvailable")

    //- UGC images
    .row
      DashHudsonScript
        template(#title="")
          h3.bold.upper.xs-f-small.md-f-small.lg-f-large.max-at-tweak.text-center Real clients, really gorgeous results

    Reviews(:product-id="product.id" :product-url-key="product.url_key")

</template>

<script>
  import { mapState, mapGetters, mapActions } from 'vuex';
  import { defineAsyncComponent } from 'vue';
  import LazyComponent from '@components/LazyComponent';
  import FixedWidthContainer from '@components/FixedWidthContainer';
  import PdpBanner from '@components/PDP/PdpBanner';
  import DefaultPdpHero from './DefaultPdpHero';
  import PdpInfoBullets from '@components/PDP/PdpInfoBullets';
  import Reviews from '@components/PDP/Reviews';
  import PdpExistingSubBanner from "@components/PDP/PdpExistingSubBanner/PdpExistingSubBanner";
  import CMSPartial from '@components/CMSPartial';
  import RPJustThere from '@components/RootPerfection/JustThere';
  import DashHudsonScript from "@components/PDP/DashHudsonScript.vue";
  import ComponentResolver from '@components/ComponentResolver';

  export default {
    name: 'DefaultPdp',

    components: {
      DashHudsonScript,
      PdpExistingSubBanner,
      LazyComponent,
      FixedWidthContainer,
      PdpBanner,
      DefaultPdpHero,
      PdpInfoBullets,
      Reviews,
      CMSPartial,
      RPJustThere,
      AccordionSections: defineAsyncComponent(() => import('@components/PDP/AccordionSections')),
      LockupBanner: defineAsyncComponent(() => import('@components/banners/lockupBanner')),
      ExpertiseIncluded: defineAsyncComponent(() => import('@components/ExpertiseIncluded')),
      PdpXsellCarousel: defineAsyncComponent(() => import('@components/PDP/PdpXsellCarousel/PdpXsellCarousel')),
      ComponentResolver,
    },

    inject: ['getObjProperty'],

    computed: {
      ...mapState('pdp', ['product']),
      ...mapState('cms', ['cmsSettings']),
      ...mapState('xsell', ['productXsellItems']),
      ...mapState('cart', ['cart']),
      ...mapGetters('pdp', ['hasActiveSub']),

      remainingXsellItemsAvailable() {
        return this.productXsellItems.filter(product => !this.cart.items.find(item => item.id === product.id));
      }
    },

    created() {
      this.isAdvisorCompleted();

      if (this.$route.query.purchasePanel || this.$route.hash == '#purchase-modal') {
        let modalPayload = {
          theme: 'full-screen'
        };

        this.openPurchasePanelModal(modalPayload);
      }
    },

    mounted() {
      if (this.product && this.product.product_type === 'root_perfection') {
        this.getRootPerfectionRecommendation();
      }
    },

    methods: {
      ...mapActions('colorAdvisor', ['isAdvisorCompleted', 'getRootPerfectionRecommendation']),
      ...mapActions('pdp', ['openPurchasePanelModal']),
    },
  };
</script>

<style scoped lang="stylus">
  .info-sections
    border-top 1px solid color-fog

  .b-line
    border-bottom 1px solid color-fog

  .info-section
    @media mq-mobile
      padding-left 5%
      padding-right 5%
      padding-top 3em
      display flex
      flex-direction column
      justify-content flex-end
      min-height 100%

      .flex-fill
        flex-grow 100
        flex-basis auto

      .close-modal
        width 100%
        padding-bottom 1.5em
</style>
